var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsGooglemapFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.58 22.742a27.193 27.193 0 012.222 3.26c.565 1.067.8 1.787 1.22 3.077.246.707.48.92.973.92.537 0 .783-.36.972-.92.393-1.21.696-2.131 1.177-3.009 1.852-3.464 4.872-5.926 6.573-9.3 0 0 1.12-2.06 1.12-4.946 0-2.69-1.104-4.559-1.104-4.559l-13.147 15.5-.007-.023z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12 16.406c1.06 2.393 3.08 4.49 4.46 6.336l7.309-8.593s-1.032 1.34-2.896 1.34c-2.078 0-3.77-1.64-3.77-3.715 0-1.427.858-2.416.858-2.416C7.702 10.15 8 11.443 7.104 16.4l.017.005z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.98 2.45c2.437.776 4.506 2.415 5.747 4.809l-5.838 6.906s.857-.994.857-2.416c0-2.117-1.802-3.715-3.746-3.715-1.846 0-2.896 1.324-2.896 1.324.448-1.012 5.08-6.565 5.884-6.907l-.007-.002z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.454 5.487C9.907 3.773 12.454 2 15.97 2c1.699 0 2.988.447 2.988.447l-5.86 6.906c-.396-.212-4.253-3.19-4.644-3.875v.01z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12 16.406s-.958-1.888-.958-4.605c0-2.575 1.016-4.832 2.299-6.29l4.643 3.874-5.977 7.02h-.006z",
    fill: "#EA4335"
  })));
}

export default SvgIconSnsGooglemapFilled;